import { Stack } from '@vtex/admin-ui'
import { FormState } from '@vtex/admin-ui-form'
import { useCollections } from 'hooks'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import { DefaultProps } from 'typings'
import { CollectionsIcon } from '../../../../icons/CollectionsIcon'
import { MultiSelect } from '../../../MultiSelect'
import { DownloadButton } from '../DownloadButton'
import { ImportButton } from '../ImportButton'
import { SelectorHeader } from '../SelectorHeader'
import { messages } from './messages'
import { LIMITS } from 'shared'

type Props = {
  name: string
  form?: FormState
  loading?: boolean
  maxEntries?: number
}

function Header(props: DefaultProps) {
  const { children } = props

  const { $t } = useIntl()

  return (
    <SelectorHeader label={$t(messages.label)} Icon={CollectionsIcon}>
      {children}
    </SelectorHeader>
  )
}

function Selector(props: Props) {
  const { $t } = useIntl()
  const { name, loading, form, maxEntries } = props
  const [searchTerm, setSearchTerm] = useState('')

  const { data: options, isLoading } = useCollections(searchTerm)

  return (
    <MultiSelect
      name={name}
      state={form}
      options={options ?? []}
      label={$t(messages.placeholder)}
      loading={loading}
      loadingOptions={isLoading}
      onSearch={setSearchTerm}
      maxEntries={maxEntries ?? LIMITS.MAX_COLLECTIONS}
    />
  )
}

export function CollectionsSelector(props: DefaultProps) {
  return (
    <Stack space="$space-2" fluid>
      {props.children}
    </Stack>
  )
}

CollectionsSelector.Header = Header
CollectionsSelector.Download = DownloadButton
CollectionsSelector.Upload = ImportButton
CollectionsSelector.Selector = Selector
